import { logError } from './services';
import { fragmentUserFull, serializeUserFull } from './serializers/serializeUser';

import GraphQLClient, {
  gql,
  sendAPIRequest,
  simplifyGraphQLJSON,
  insertGraphQLFragments,
  getErrorMessageFromResponse,
} from './GraphQLClient';


export function getAuthTokenByEmailAndPassword(email, password){
  const query = `
    mutation ($email: String!, $password: String!) {
      loginByEmail(email: $email, password: $password)
    }
  `;
  const publicGraphQLClient = new GraphQLClient();
  publicGraphQLClient.initialize({ url: process.env.API_URL });

  return publicGraphQLClient.query(query, { email, password })
    .then(({ loginByEmail }) => loginByEmail)
    .catch(error => {
      logError('getAuthTokenByEmailAndPassword: ' + getErrorMessageFromResponse(error), { error });
      throw error;
    });
}


export function getCompanyList() {
  const query = gql`
    {
      companies {
        id
        name
        unreadMessagesCount
      }
    }
  `;
  return sendAPIRequest(query);
}


export async function getCompanyOperators(companyId, limit = 100) {
  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!, $limit: Int) {
      companyEmployees(companyId: $companyId, first: $limit) {
        edges {
          cursor
          node {
            ...fragmentUserFull
          }
        }
      }
    }
  `, { fragmentUserFull });

  return sendAPIRequest(query, { companyId, limit }).then(operators => {
    return simplifyGraphQLJSON(operators).map(serializeUserFull);
  });
}


export function getCurrentOperator(companyId){
  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!) {
      profile(companyId: $companyId) {
        ...fragmentUserFull
        switchOffAvailable
      }
    }
  `, { fragmentUserFull });
  return sendAPIRequest(query, { companyId }).then(currentOperator => {
    return serializeUserFull({ ...currentOperator, isCurrentOperator: true });
  });
}


export function updateCurrentOperator(options){
  const { companyId, firstName, lastName, avatarFile } = options || {};
  const query = insertGraphQLFragments(gql`
    mutation ($companyId: Uuid!, $firstName: String, $lastName: String, $avatar: Upload) {
      updateProfile(companyId: $companyId, firstName: $firstName, lastName: $lastName, avatar: $avatar) {
        ...fragmentUserFull
      }
    }
  `, { fragmentUserFull });

  let binaries;
  let variables = {
    companyId,
    firstName,
    lastName,
  };
  if (avatarFile) {
    variables.avatar = avatarFile.name;
    binaries = { [avatarFile.name]: avatarFile };
  }
  return sendAPIRequest(query, variables, binaries).then(currentOperator => {
    return serializeUserFull({ ...currentOperator, isCurrentOperator: true });
  });
}


export function deleteCurrentOperatorPhoto(companyId){
  const query = gql`
    mutation ($companyId: Uuid!, $avatar: Upload) {
      updateProfile(companyId: $companyId, avatar: $avatar) {
        id
      }
    }
  `;
  return sendAPIRequest(query, { companyId, avatar: null });
}


export function changeCurrentOperatorPassword(oldPassword, newPassword){
  const query = insertGraphQLFragments(gql`
    mutation ($oldPassword: String!, $newPassword: String!) {
      changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
        id
      }
    }
  `);
  return sendAPIRequest(query, { oldPassword, newPassword });
}
